import { Typography } from "@mui/material";

import { lessonType } from "../../../../constants";
import { useTeachingPreview } from "../hooks/useTeachingPreview";

export function LessonInfo() {
	const { currentLesson } = useTeachingPreview();

	if (!currentLesson) {
		return null;
	}

	return (
		<div className="item-separator-small">
			<Typography className="big-text bold">{currentLesson.title}</Typography>
			<Typography
				className="normal-text"
				whiteSpace="break-spaces"
				textAlign="justify">
				{currentLesson.description}
			</Typography>
			{currentLesson.type === lessonType.ONSITE && (
				<div className="lesson-time-container item-separator-small">
					<div>
						<Typography className="normal-text bold">
							Appointment Date
						</Typography>
						<Typography className="normal-text">
							[Date], [Start Time] - [End Time]
						</Typography>
					</div>
					{currentLesson.teachingTime && (
						<div>
							<Typography className="normal-text bold">
								Teaching Time
							</Typography>
							<Typography className="normal-text">{`${(currentLesson.teachingTime / 60).toFixed(1)} hrs`}</Typography>
						</div>
					)}
					{currentLesson.flightTime && (
						<div>
							<Typography className="normal-text bold">Flight Time</Typography>
							<Typography className="normal-text">{`${(currentLesson.flightTime / 60).toFixed(1)} hrs`}</Typography>
						</div>
					)}
					{currentLesson.airplane && (
						<div>
							<Typography className="normal-text bold">
								Aircraft or Sim Type
							</Typography>
							<Typography className="normal-text">
								{currentLesson.airplane}
							</Typography>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
